export default __webpack_public_path__ + "static/media/kitchen4-afterE-480w.a80c9c61.png";